import { INotesSection } from '@modeso/types__aumico-lib-annualreport-be';

export interface IAnnualReportAccordionsData {
    accordions: INotesSection[];
}
